import * as React from "react";
import {
  Admin,
  Resource,
  defaultTheme,
  localStorageStore,
  CustomRoutes
} from 'react-admin';

import { ContainerLayout } from '@react-admin/ra-navigation';

/* import { Dashboard } from './components/dashboard/Dashboard'; */
import { MyLayout } from "./components/shared/Layout/Layout";

// Setup rotte
import { Route } from 'react-router-dom';

///////////////////////////////
import { restClient, authClient } from 'ra-data-feathers';
import feathersClient from './feathersClient';

// Importo il tema
import { myTheme } from "./components/shared/theme";

// Importo tutti i componenti principali
import { QuizList, QuizEdit } from './components/quiz/quiz';

/* Login page custom */
import MyLoginPage from './components/loginpage/MyLoginPage';

/* Not Found page custom */
import NotFoundPage from './components/NotFoundPage/NotFoundPage';

// Decoder per il JWT
import decodeJwt from 'jwt-decode';

const restClientOptions = {
  id: 'id', // In this example, the database uses '_id' rather than 'id'
  usePatch: true // Use PATCH instead of PUT for updates
};

const options = {
  id: '_id',
  storageKey: 'feathers-jwt', // The key in localStorage used to store the authentication token
  authenticate: { // Options included in calls to Feathers client.authenticate
    strategy: 'local', // The authentication strategy Feathers should use
  },
  permissionsKey: 'permissions', // The key in localStorage used to store permissions from decoded JWT
  permissionsField: 'roles', // The key in the decoded JWT containing the user's role
  passwordField: 'password', // The key used to provide the password to Feathers client.authenticate
  usernameField: 'email', // The key used to provide the username to Feathers client.authenticate
  redirectTo: '/login', // Redirect to this path if an AUTH_CHECK fails. Uses the react-admin default of '/login' if omitted.
  logoutOnForbidden: true, // Logout when response status code is 403
  /* Allows to use custom query operators from various feathers-database-adapters in GET_MANY calls.
 * Will be merged with the default query operators ['$gt', '$gte', '$lt', '$lte', '$ne', '$sort', '$or', '$nin', '$in']
 */
  customQueryOperators: ['$gt', '$gte', '$lt', '$lte', '$ne', '$sort', '$or', '$nin', '$in']

}

export const theme = {
  ...defaultTheme,
  overrides: {
    /*     RaSidebar: {
          drawerPaper: {
            width: 300,
          },
          fixed: {
            zIndex: 1200,
          },
        }, */
    RaSidebar: {
      fixed: {
        position: 'inherit'
      }
    },
  },
};

// Init store
const storeGenerale = localStorageStore();

// Debug per problema con ra_calendar
const feathersDataProvider = restClient(feathersClient, restClientOptions);

const myDataProvider = async (verb, resource, params) => {
  const result = await feathersDataProvider(verb, resource, params);
  if (resource === 'events') {
    console.log(":::: DEBUG START :::: EVENTS");
    const service = feathersClient.service(resource);
    const query = {}; // Build your query here
    const risultato = service.find({ query });
    //TODO: devo chiedere a feathersjs che ruolo ha lo user con l'email specificata
    console.log(resource, risultato);
    return risultato;
  }
  return result;
}

const feathersAuthProvider = authClient(feathersClient, options);
const myAuthProvider = async (verb, resource, params) => {
  const result = await feathersAuthProvider(verb, resource, params);

  if (typeof (resource) != "undefined") {
    try {
      if (typeof (resource['username']) != "undefined") {

        // Reset variabili
        storeGenerale.setItem('profile.name', "");
        storeGenerale.setItem('profile.roles', "");

        // console.log(":::: DEBUG START AUTH ::::");
        // console.log(resource);
        // console.log(resource['username']);
        var test = localStorage.getItem("feathers-jwt");
        const decodedToken = decodeJwt(test);
        // console.log("---- token decodificato ----");
        // console.log(decodedToken);
        // console.log(localStorage.getItem('permissions'));
        storeGenerale.setItem('profile.name', decodedToken.username);
        storeGenerale.setItem('profile.email', decodedToken.email);
        storeGenerale.setItem('profile.roles', decodedToken.roles);
        storeGenerale.setItem('profile.idUser', decodedToken.id);
        // storeGenerale.setItem('profile.ruolo','admin');
        // console.log(":::: DEBUG STOP AUTH ::::");
      }
    } catch (error) {
      console.log(error);
    }
  }

  return result;
}

/* --- */



const App = () => {

  return (
    <Admin
      title='Area Candidato'
      catchAll={NotFoundPage}
      store={storeGenerale}
      layout={MyLayout} // Include il menu

      // dashboard={Dashboard}
      loginPage={MyLoginPage}
      theme={myTheme}
      dataProvider={myDataProvider}
      authProvider={myAuthProvider}
    >



      {permissions => [
        permissions === 'candidato' ?
          <>{<Resource name="tbl-quiz"
            list={QuizList}
            edit={QuizEdit}
          />}

            {<Resource name="tbl-quiz-domande" />}

            {<Resource name="tbl-domande" />}

            {<Resource name="view-quiz-avanzamento" />}
          </> : <></>]}

    </Admin>
  );
}

export default App;